import { useState } from 'react';

import { useAppDispatch } from '@maestra/core/store/store';
import { authActions, type SocialProvider } from '@maestra/core/store/slices/auth';

// O LOGIN SOCIAL (o Google) — do antigo `AuthShell`, sem o desenho.

export const NOME_DO_PROVEDOR: Record<SocialProvider, string> = {
  google: 'Google',
  apple: 'Apple',
  facebook: 'Facebook',
};

export const useEntrarComProvedor = () => {
  const dispatch = useAppDispatch();
  // A Apple SAIU DA WEB por enquanto (pedido do Lucas, 02/10/2026): no celular ela aparecia e sumia
  // conforme a largura da tela. O Sign in with Apple continua no aplicativo nativo (`apps/mobile`),
  // onde a App Store o exige (diretriz 4.8). Para voltar, é pôr 'apple' aqui de novo.
  const provedores: SocialProvider[] = ['google'];

  const [aviso, setAviso] = useState<string | null>(null);
  // QUAL provedor está redirecionando, e não um booleano: com dois botões, um booleano deixaria
  // os dois em "Redirecionando…".
  const [redirecionando, setRedirecionando] = useState<SocialProvider | null>(null);

  // Dispara o OAuth: o Supabase redireciona para o provedor e volta em /auth/callback.
  const entrar = async (provider: SocialProvider) => {
    const nome = NOME_DO_PROVEDOR[provider];
    setAviso(null);
    setRedirecionando(provider);
    try {
      await dispatch(authActions.signInWithProvider(provider)).unwrap();
    } catch (err: any) {
      setRedirecionando(null);
      const msg = String(err?.message || '').toLowerCase();
      setAviso(
        msg.includes('not enabled') || msg.includes('provider')
          ? `Login com ${nome} indisponível no momento. Use e-mail e senha.`
          : `Não foi possível iniciar o login com ${nome}. Tente novamente.`,
      );
    }
  };

  return { provedores, aviso, redirecionando, entrar };
};
